import { Injectable } from '@angular/core';
import { SimpleSubscriptionRequestInterface } from "../../models/auth";
import { HttpBaseService } from "@gea-waldviertler-website/shop-lib";

@Injectable()
export class HttpSubscriptionsService extends HttpBaseService {

  subscribe(data: SimpleSubscriptionRequestInterface) {
    const url: string = this.getMainApiBaseUrl() + "/subscriptions/subscribe"
    return this.http.post<boolean>(url, data)
  }
}
